import type { AiFormFillInput, AiFormFillResult } from "../WarehouseApi";
import type { WarehouseApiModuleContext } from "./WarehouseApiModuleContext";

type NormalizeAiFormFillResult = (payload: unknown) => AiFormFillResult;

interface AiApiModuleDependencies {
  normalizeAiFormFillResult: NormalizeAiFormFillResult;
}

export class AiApiModule {
  constructor(
    private readonly context: Pick<WarehouseApiModuleContext, "sendJson">,
    private readonly deps: AiApiModuleDependencies,
  ) {}

  async fillFormDraft(input: AiFormFillInput): Promise<AiFormFillResult> {
    const rawTranscript =
      typeof input.transcript === "string" ? input.transcript.trim() : "";
    const transcript = rawTranscript.length >= 4 ? rawTranscript : "";
    const photo = typeof input.photo === "string" ? input.photo.trim() : "";

    if (!transcript && !photo) {
      throw new Error(
        "Добавьте текст (минимум 4 символа) или фото для AI-автозаполнения",
      );
    }

    const payloadBody: {
      entity: AiFormFillInput["entity"];
      transcript?: string;
      photo?: string;
    } = {
      entity: input.entity,
    };
    if (transcript) {
      payloadBody.transcript = transcript;
    }
    if (photo) {
      payloadBody.photo = photo;
    }

    const payload = await this.context.sendJson<unknown>(
      "/api/ai/form-fill",
      "POST",
      payloadBody,
    );

    return this.deps.normalizeAiFormFillResult(payload);
  }
}
